import { render, staticRenderFns } from "./SearchPageHotelCardRightBlock.vue?vue&type=template&id=2b227e0d&scoped=true&"
import script from "./SearchPageHotelCardRightBlock.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SearchPageHotelCardRightBlock.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./SearchPageHotelCardRightBlock.vue?vue&type=style&index=0&id=2b227e0d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b227e0d",
  null
  
)

export default component.exports